import { getClerkToken } from '../renderer/clerk';
import { isNetworkError, isOnline, reportNetworkFailure, reportNetworkSuccess } from "./connectivity";
export class OfflineError extends Error {
    constructor() {
        super("Offline - this action requires a connection");
        this.name = "OfflineError";
    }
}
export async function authedFetch(input, init) {
    if (!isOnline()) {
        throw new OfflineError();
    }
    const token = await getClerkToken();
    const headers = token ? new Headers(init?.headers) : init?.headers;
    if (token && headers instanceof Headers) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    try {
        const response = await fetch(input, { ...init, headers });
        reportNetworkSuccess();
        return response;
    }
    catch (err) {
        if (isNetworkError(err)) {
            reportNetworkFailure();
            throw new OfflineError();
        }
        throw err;
    }
}
